export const IconArrow = ({
  width = 20,
  height = 21,
  color = '#777',
  rotation = 0,
  css,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={css}
    style={{ transform: `rotate(${rotation}deg)` }}
  >
    <path
      d='M9.99949 11.5769L13.538 8.03854C13.616 7.96049 13.7116 7.91882 13.8249 7.91354C13.9381 7.90813 14.039 7.94979 14.1276 8.03854C14.2164 8.12715 14.2607 8.22542 14.2607 8.33334C14.2607 8.44125 14.2164 8.53952 14.1276 8.62813L10.4707 12.2852C10.398 12.3578 10.3237 12.4089 10.2478 12.4383C10.172 12.4676 10.0892 12.4823 9.99949 12.4823C9.90977 12.4823 9.82699 12.4676 9.75116 12.4383C9.67533 12.4089 9.60102 12.3578 9.52824 12.2852L5.87137 8.62813C5.79331 8.55021 5.75165 8.45459 5.74637 8.34125C5.74095 8.22806 5.78262 8.12715 5.87137 8.03854C5.95998 7.94979 6.05824 7.90542 6.16616 7.90542C6.27408 7.90542 6.37234 7.94979 6.46095 8.03854L9.99949 11.5769Z'
      fill={color}
    />
  </svg>
);
